<div class="row pb-2 m-0">
    <div class="col"></div>
    <div class="col-auto">
        <!-- <button 
            *ngIf="this.common.PageRight.IsAdd" type="button" class="btn btn-primary"
            [routerLink]="['/master/holiday/site/add',0]" 
            [disabled]="isDisabled">
            <i class="bi bi-plus-lg" *ngIf="!isDisabled"></i>
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" *ngIf="isDisabled"></span>
            {{!isDisabled?'Add Site Holiday Mapping':'Loading...'}}
        </button> -->

        <button type="button" class="btn btn-primary btn-sm" [routerLink]="['/excdays/add',0]" [disabled]="isDisabled">
            <i class="bi bi-plus-lg" *ngIf="!isDisabled"></i>
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" *ngIf="isDisabled"></span>
            {{!isDisabled?'Add Exceptional Days':'Loading...'}}
        </button>
    </div>
</div>
<div class="card">
    <div class="card-header">
        Exceptional Days
    </div>
    <div class="card-body">
        <div class="row ">
            <div class="row">
                <div class="col-auto">
                    <label>Year : </label>
                </div>
                <div class="col-md-2">
                    <select name="Year" (change)="HistoryFilterOnYear()" class="form-select" [(ngModel)]="filter.Year"
                        #Year="ngModel" required>
                        <option *ngFor="let Year of Years" [value]="Year">
                            {{Year}}
                        </option>
                    </select>
                </div>
            </div>
        </div>

        <div class="mt-2">
            <table datatable [dtOptions]="common.commonDToptions" width="100%" [dtTrigger]="dtTrigger"
                class="customeDatatable table table-bordered pt-2 mt-2">
                <thead class="table-light">
                    <tr>
                        <!-- <th style="width: 5px;" [ngClass]="{'colHide': !this.common.PageRight.IsEdit}">Action</th> -->
                        <th>Date</th>
                        <th>Branch</th>
                        <th>Site</th>
                        <th>Action</th>
                        <!-- <th>CreatedBy</th>
                    <th>CreatedOn</th> -->
                    </tr>
                </thead>
            </table>
        </div>

    </div>
    <div class="card-footer">
        <div class="row">
            <div class="col"></div>
            <div class="col-auto">
                <button (click)="excelDownload()" class="btn btn-primary btn-sm"><i
                        class="bi bi-file-earmark-spreadsheet"></i> Excel</button>
            </div>
        </div>
    </div>
</div>